<template>
    <div>
        <banner img-path="meeting.jpg" banner-text="Partners"/>
        <b-container>
            <b-row>
                <div v-for="(companyDetails, company, idx) in partners" :key="'company-card-' + idx" class="fadeable">
                    <b-card :img-src="require('../assets/img/logos/' + companyDetails.logoFile)" img-alt="Card image" img-left class="mb-3 company-description">
                        <b-card-text>
                            <div class="company-card-img-top-wrapper">
                                <img :src="require('../assets/img/logos/' + companyDetails.logoFile)" alt="" class="company-card-img-top"><br id="company-logo-br">
                            </div>
                            <span class="company-name"> {{company}} </span> {{companyDetails.description}}
                        </b-card-text>
                        <b-button v-if="'site' in companyDetails" :href="companyDetails.site" pill variant="primary" target="_blank">Go to site ↗</b-button>
                        <a v-if="'linkedin' in companyDetails" :href="companyDetails.linkedin" target="_blank"><img class="social-media-icons-distributors" src="../assets/img/linkedin-logo.png" alt=""></a>
                        <a v-if="'facebook' in companyDetails" :href="companyDetails.facebook" target="_blank"><img class="social-media-icons-distributors" src="../assets/img/facebook-logo.png" alt=""></a>
                    </b-card>
                </div>
            </b-row>
        </b-container>
    </div>
</template>

<script>
import banner from '@/components/Banner.vue'

export default {
    components: {
        banner
    },
    // eslint-disable-next-line
    name: 'Partners',
    data(){
        return{
            partners: require('../assets/partners.json')
        }
    },
    created() {
        window.addEventListener('scroll', this.activateFadeables);
    },
    destroyed() {
        window.removeEventListener('scroll', this.activateFadeables);
    }
}
</script>